import { useEffect } from "react";
import { useEffectOnce } from "react-use";

import Cookies from "js-cookie";

import { useLadyIdContext } from "@/context/LadyId.context";

const onLocationChange = (ladyId: string | undefined) => {
  const href = window.location.href;
  const id = ladyId || href.match(/\/lady\/id(\d+)/)?.[1];

  if (!id) {
    Cookies.remove("linkLadyId");
    return;
  }

  Cookies.set("linkLadyId", id);
};

let oldHref = "";

export const useSetLadyCookieOnMount = () => {
  const { ladyId } = useLadyIdContext();

  useEffect(() => {
    onLocationChange(ladyId);
  }, [ladyId]);

  useEffect(() => {
    const createObserver = () => {
      const observer = new MutationObserver(function (_mutations) {
        if (oldHref !== document.location.href) {
          oldHref = document.location.href;
          onLocationChange(ladyId);
        }
      });

      observer.observe(window.document.body, {
        childList: true,
        subtree: true,
      });

      return observer;
    };

    const observer = createObserver();

    return () => {
      observer.disconnect();
    };
  }, [ladyId]);

  useEffectOnce(() => {
    const removeCookie = () => {
      document.cookie = "linkLadyId=; Max-Age=0; path=/;";
    };

    window.addEventListener("beforeunload", removeCookie);

    return () => {
      window.removeEventListener("beforeunload", removeCookie);
    };
  });
};
